import { Card } from '@/components/ui/card';
import { Share2, Download, Users } from 'lucide-react';
import { cn } from '@/lib/utils';

interface TabCardsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  mySharesCount: number;
  sharedWithMeCount: number;
  groupsCount: number;
}

export function TabCards({
  activeTab,
  onTabChange,
  mySharesCount,
  sharedWithMeCount,
  groupsCount,
}: TabCardsProps) {
  const cards = [
    {
      id: 'shares',
      title: 'Meus Compartilhamentos',
      icon: Share2,
      count: mySharesCount,
      description: 'recursos compartilhados',
      color: 'text-blue-600 dark:text-blue-400',
      tourId: 'sharing-tab-meus-compartilhamentos',
    },
    {
      id: 'shared-with-me',
      title: 'Compartilhados Comigo',
      icon: Download,
      count: sharedWithMeCount,
      description: 'recursos recebidos',
      color: 'text-green-600 dark:text-green-400',
      tourId: 'sharing-tab-compartilhados-comigo',
    },
    {
      id: 'groups',
      title: 'Grupos',
      icon: Users,
      count: groupsCount,
      description: 'grupos ativos',
      color: 'text-purple-600 dark:text-purple-400',
      tourId: 'sharing-tab-grupos',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {cards.map((card) => {
        const Icon = card.icon;
        const isActive = activeTab === card.id;

        return (
          <Card
            key={card.id}
            className={cn(
              'cursor-pointer transition-all duration-200 hover:shadow-lg',
              isActive
                ? 'ring-2 ring-primary shadow-md'
                : 'hover:border-primary/50'
            )}
            onClick={() => onTabChange(card.id)}
            data-tour={card.tourId}
          >
            <div className="p-6">
              <div className="flex items-start gap-4">
                <div className={cn('p-3 rounded-lg bg-muted', card.color)}>
                  <Icon className="h-6 w-6" />
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-sm mb-1">{card.title}</h3>
                  <p className="text-2xl font-bold mb-1">{card.count}</p>
                  <p className="text-xs text-muted-foreground">
                    {card.description}
                  </p>
                </div>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
}
